import React from "react";
import { leaderAvatarSrc } from "../lib/avatars";

function fmt(s) {
  if (s == null) return "—";
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${String(r).padStart(2, "0")}`;
}

function firstName(n) {
  return (n || "").trim().split(/\s+/)[0] || "—";
}

const RANK_META = {
  1: { ring: "#E0B860", medal: "🥇", size: 60, badge: "#E8A365" },
  2: { ring: "#CBB9AC", medal: "🥈", size: 46, badge: "#D0A98F" },
  3: { ring: "#B98A5E", medal: "🥉", size: 46, badge: "#B98A5E" },
};

function Spot({ entry }) {
  const meta = RANK_META[entry.rank] || RANK_META[3];
  const isFirst = entry.rank === 1;
  return (
    <div
      data-testid={`podium-rank-${entry.rank}`}
      className="flex flex-col items-center gap-1.5 min-w-0"
      style={{ width: meta.size + 18 }}
    >
      <div className="text-base leading-none" aria-hidden="true">{meta.medal}</div>
      <div
        className="relative rounded-full bg-cover bg-center shrink-0"
        style={{
          width: meta.size,
          height: meta.size,
          border: `2px solid ${meta.ring}`,
          backgroundImage: `url(${leaderAvatarSrc(entry)})`,
          boxShadow: `0 6px 14px -6px ${meta.badge}`,
        }}
      >
        <div
          className="absolute -bottom-1 -right-1 w-4 h-4 rounded-full grid place-items-center text-[9px] font-bold text-white tabular-nums shadow"
          style={{ background: meta.badge }}
        >
          {entry.rank}
        </div>
      </div>
      <p
        className="text-[12px] font-medium leading-none tracking-tight truncate max-w-full"
        style={
          isFirst
            ? {
                fontFamily: "Outfit, sans-serif",
                background: "linear-gradient(180deg, #F2D88A 0%, #C99A3B 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }
            : { color: "rgba(255,255,255,0.82)" }
        }
      >
        {firstName(entry.name)}
      </p>
      <p className="text-[10px] text-white/50 tabular-nums leading-none">{fmt(entry.time_sec)}</p>
    </div>
  );
}

/**
 * Podium — 1-2-3 winners display (gold / silver / bronze).
 * 1st place sits larger in the center, 2nd left, 3rd right.
 */
export default function Podium({ entries = [] }) {
  if (!entries.length) return null;
  const byRank = {};
  entries.forEach((e) => { byRank[e.rank] = e; });
  const ordered = [byRank[2], byRank[1], byRank[3]].filter(Boolean);

  return (
    <div data-testid="podium" className="flex items-end justify-center gap-4 sm:gap-6">
      {ordered.map((e) => (
        <Spot key={e.rank} entry={e} />
      ))}
    </div>
  );
}
